import { TranslateService } from "@ngx-translate/core";
import {
	Capacitor,
	App,
	NetworkStatus,
	PluginListenerHandle
} from "@capacitor/core";
import { Injectable } from "@angular/core";
import { NetworkService } from "./network.service";
import { MessageService } from "../message/message.service";
import { ActiveToast } from "ngx-toastr";
import { EMessageLevel } from "../message/option/message-level.e";

@Injectable()
export class MobileNetworkService extends NetworkService {
	// tslint:disable-next-line: variable-name
	private _messageInst: ActiveToast<any>;
	// tslint:disable-next-line: variable-name
	private _subscriber: PluginListenerHandle;

	// tslint:disable-next-line: variable-name
	private _currentState: NetworkStatus;

	constructor(private messageService: MessageService, private translate: TranslateService) {
		super();
	}

	intinialize() {
		// this.registerNetworkChange();
		return Promise.resolve(true);
	}

	public pushState(state: NetworkStatus) {
		this.networkChangeState$.next(state.connected);
		this.messageHandler(state);
		this._currentState = state;
	}

	protected registerNetworkChange() {
		Capacitor.Plugins.Network.getStatus().then(obj => {
			this.messageHandler(obj);
		}).catch(err => { /* Nothing to do*/ });
		this._subscriber = Capacitor.Plugins.Network.addListener(
			"networkStatusChange",
			(status: NetworkStatus) => {
				this.networkChangeState$.next(status.connected);
				this.messageHandler(status);
			}
		);
	}

	private messageHandler(status: NetworkStatus) {
		if (!status.connected && (this._currentState && !this._currentState.connected)) {
			this._messageInst = this.messageService.present(
				{
					content: this.translate.instant("Check your internet connection and try again"),
					freeze: true,
					tabDismiss: false,
					class: "freeze-toast"
				},
				EMessageLevel.FREESTYLE
			);
		} else {
			if (this._messageInst && (this._currentState && this._currentState.connected)) {
				this.messageService.dismiss(this._messageInst.toastId);
				this._messageInst = null;
			}
		}
	}

	public unsubscribeNetworkChange() {
		this._subscriber.remove();
		this._messageInst = null;
	}
}
